import { ExperienceShell } from "@/app/ExperienceShell";
import { RuntimeErrorBoundary } from "@/app/RuntimeErrorBoundary";

export function App() {
  return <RuntimeErrorBoundary><ExperienceShell /></RuntimeErrorBoundary>;
}
